<div class="form-group row" *ngIf="control.visible" [formGroup]="formGroup">
  <div class="col-md-12 modal-header-separator">
    <h4 class="modal-title-separator pull-left">{{control.label}}</h4>
  </div>
</div>
